<template>
  <FaIcon :icon="['far', DEVICE_DEFAULT_INPUT_ICON]" />
</template>

<script setup lang="ts">
import { DEVICE_DEFAULT_INPUT_ICON } from '@/constants/device'
</script>
